export enum Direction {
  Exact,
  AtLeast,
  AtMost,
}
